if (!customElements.get("cart-item-otp-switch")) {
  class CartItemOtpSwitch extends HTMLElement {
    constructor() {
      super();
      this.button = this.querySelector(".cart-item-otp-switch__btn");

      this.boundHandleClick = this.handleClick.bind(this);
    }

    connectedCallback() {
      if (this.button) {
        this.button.addEventListener("click", this.boundHandleClick);
      }
    }

    disconnectedCallback() {
      if (this.button) {
        this.button.removeEventListener("click", this.boundHandleClick);
      }
    }

    handleClick() {
      if (this.button.classList.contains("btn--loading")) return;
      this.button.classList.add("btn--loading");

      let sectionsToBundle = [];
      document.documentElement.dispatchEvent(
        new CustomEvent("cart:grouped-sections", {
          bubbles: true,
          detail: { sections: sectionsToBundle },
        })
      );

      const lineRef = this.dataset.lineKey
        ? { id: this.dataset.lineKey }
        : { line: this.dataset.lineIndex };

      // Removing the selling plan converts the line to a one-time purchase.
      // Mirror image of cart-item-subscription-actions.js, which sets one.
      fetch(`${FoxTheme.routes.cart_change_url}`, {
        ...FoxTheme.utils.fetchConfig(),
        ...{
          body: JSON.stringify({
            ...lineRef,
            quantity: this.dataset.qty,
            selling_plan: null,
            sections: sectionsToBundle,
          }),
        },
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.status && !data.items) {
            data.errors = data.errors || data.description || data.message;
          }
          FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, {
            cart: data,
            sources: "otp-switch",
            line: this.dataset.lineIndex,
            name: "selling_plan",
          });
        })
        .catch((error) => {
          console.error("Error removing line item selling plan -> ", error);
          this.button.classList.remove("btn--loading");
        });
    }
  }

  customElements.define("cart-item-otp-switch", CartItemOtpSwitch);
}
